
import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

  @Injectable()
  export class ArchivosService {
    private http:HttpClient;
    private baseUrl: string;
    constructor(_http: HttpClient, _baseUrl: string) {
      this.http = _http;
      this.baseUrl = _baseUrl;
    }
    
    public upload = (paramsUrl:any,params:any) : Promise<any> => {
      return this.http.post(this.baseUrl + 'archivos/upload' + paramsUrl, params).toPromise()
        .then(result => {
          return result;
        })
        .catch(error => Promise.reject(error));
    }
    
    public eliminar = (params:any) : Promise<any> => {
      return this.http.get(this.baseUrl + 'archivos/eliminar' + params).toPromise()
        .then(result => {
          return result;
        })
        .catch(error => Promise.reject(error));
    }
    
  }

